module.exports = __webpack_public_path__ + "img/admin-a7.5c442cb8.png";